import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: border-box;
    padding-top: 15px;
    border-top: thin solid var(--border-color);
`
